// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1DUte","info":"Note_info__3CKj8","note":"Note_note__3tB8a","actions":"Note_actions__2GZwP"};